import React, { Component, Fragment } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../actions/baseActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import Dnd from "../DragAndDrop/DragAndDrop";
import Loading from "../Loading";

import "./css/lsc.css";

class Lsc extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lesson: null,
      selectedSlide: null,
      loading: true,
      selectedLessons: []
    };
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillMount() {
    axios
      .get(`${URL.api}content/los/listLosLos/${this.props.content.id}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.success) {
            let lesson = this.props.content;
            lesson.slides = [];
            lesson.slides = resp.data.data;
            this.setState(
              {
                lesson
              },
              () => {
                this.selectSlide(lesson.slides[0]);
              }
            );
          }
        },
        error => {
          if (error.response.statusText === "Unauthorized") {
            this.props.logout(this.props.user.token);
          }
        }
      );
  }

  selectSlide = slide => {
    this.toggleLoading(true);
    this.setState(
      {
        selectedSlide: slide
      },
      () => {
        this.toggleLoading(false);
      }
    );
  };

  toggleLoading = state => {
    this.setState({
      loading: state
    });
  };

  getOrder = list => {
    this.setState(
      {
        lesson: {
          // eslint-disable-next-line react/no-access-state-in-setstate
          ...this.state.lesson,
          slides: list
        }
      },
      () => {
        this.finalize();
      }
    );
  };

  checked = item => {
    this.selectSlide(item);
    let { selectedLessons } = this.state;
    if (selectedLessons.length === 0) {
      selectedLessons.push(item);
    } else {
      selectedLessons.forEach((selected, idx) => {
        if (item.id === selected.id) {
          selectedLessons.splice(idx, 1);
        } else {
          selectedLessons.push(item);
        }
      });
    }
    this.setState(
      {
        selectedLessons
      },
      () => {
        this.finalize();
      }
    );
  };

  finalize = () => {
    this.props.getSelected(this.state.lesson);
  };

  send = () => {
    this.props.send();
  };

  render() {
    return (
      <Fragment>
        <div className="warp-lsc">
          <div className="warp-side-lsc">
            {this.state.loading ? (
              <Loading color="123abc" loading top="27" left="10" />
            ) : (
              <div className="warp-img-lsc">
                <img src={URL.img + this.state.selectedSlide.image} alt="" />
                <h4>{this.state.selectedSlide.name}</h4>
              </div>
            )}
          </div>
          <div className="warp-side-lsc">
            {this.state.loading ? (
              <Loading color="123abc" loading top="27" left="10" />
            ) : (
              <Dnd
                list={this.state.lesson.slides}
                getOrder={this.getOrder}
                direction="vertical"
                orderOnly
                checkbox
                getChecked={this.checked}
              />
            )}
          </div>
        </div>
        <button
          className="btn btn-primary"
          onClick={this.send}
          style={{ float: "right" }}
        >
          <i className="fa fa-check"></i>
          <span>Enviar</span>
        </button>
      </Fragment>
    );
  }
}
const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Lsc);
